import Search from '~/models/abstracts/Search'

export class SuppliersSearch extends Search {
  static entity = 'supplierssearch'

  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null)
    }
  }

  toString () {
    return this.name
  }
}

export default SuppliersSearch
